<template>
  <div>
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" v-model="searchtxt" placeholder="Search by Name"
            class="is-label-placeholder" />
        </div>
      </div>
      <div class="content-header-right">
        <!--filter dropdown-->
        <vs-dropdown  vs-custom-content vs-trigger-click>
          <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
            icon-after>
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button>
          <vs-dropdown-menu ref="filter_menu" class="filters-content">
           
           <div class="filters-form-fileds">
              <div class="form-container">
               <div class="vx-row">

                <!---
            countries:[],
     states:[],
     locations:[],
     selectedCountry:null,
     selectedState:null,
     selectedCityes:[],
    -->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Status</label>
                    
                    <multiselect v-model="selected_statusids" :options="all_statusids" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template> 
                    </multiselect>
                  </div>

                   <div class="vx-col  md:w-1/3 w-full con-select">
            
                  <label class="typo__label">Company Type</label>

                   <multiselect v-model="selectedTenantTypeForFilter" :options="tenantTypes" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Company Type" label="name" track-by="name" :preselect-first="false">
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template> 
                    </multiselect>
               
                                          

                  
              </div> 

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Country/Territory</label>
                    <multiselect name="spouseaddresscountry"   v-model="selectedCountry"
                          @input="changedCountry" :show-labels="false" track-by="id" label="name"
                          data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                          :allow-empty="false">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template> 
                          </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                     <label for class="typo__label">State</label>
                        <multiselect name="State"   v-model="selectedState"
                          @input="changedState" :show-labels="false" track-by="id" label="name" data-vv-as="State" :multiple="false"
                          placeholder="Select State" :options="states" :searchable="true" :allow-empty="true">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template> 
                        </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                     <label for class="typo__label">City</label>
                        <multiselect name="city"   v-model="selectedCityes"
                        @input="changedCity"
                        :show-labels="false" track-by="id" label="name" data-vv-as="City"
                          placeholder="Select City" :options="locations" :searchable="true" :allow-empty="true" :multiple="true" :hideSelected="true">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                          </template> 
                        </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                       :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                    ></date-range-picker>
                  </div>
                </div>
                   
                   
     
              </div>
            </div>
            <!--
            <div class="filters-form-fileds">
              <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full con-select">
                      <label class="typo__label">Select Status</label>
                    
                      <multiselect v-model="selected_statusids" :options="all_statusids" :multiple="true" :hideSelected="true"
                        :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                        placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                        
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Status Selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                        </template> 
                      </multiselect>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select">
                      <label class="typo__label">Country</label>
                      <multiselect name="spouseaddresscountry"   v-model="selectedCountry"
                            @input="changedCountry" :show-labels="false" track-by="id" label="name"
                            data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                            :allow-empty="false"></multiselect>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select">
                      <label for class="typo__label">State</label>
                          <multiselect name="State"   v-model="selectedState"
                            @input="changedState" :show-labels="false" track-by="id" label="name" data-vv-as="State" :multiple="false"
                            placeholder="Select State" :options="states" :searchable="true" :allow-empty="true">
                          </multiselect>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select">
                      <label for class="typo__label">City</label>
                          <multiselect name="city"   v-model="selectedCityes"
                          @input="changedCity"
                          :show-labels="false" track-by="id" label="name" data-vv-as="City"
                            placeholder="Select City" :options="locations" :searchable="true" :allow-empty="true" :multiple="true" :hideSelected="true">
                          </multiselect>
                    </div>
                  </div>
              </div>
            </div>
            -->
            <div class="filters-status">
              <div class="left-buttons">
              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- end -->
        <vs-button type="border" class="light-blue-btn" @click="inviteUserPopupshow(true)">Invite Customer<span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span>
        </vs-button>  
      </div>
    </div>

    <NoDataFound :loading="!contentLoaded" v-if="users.length == 0 && !callFromSerch" content="No Customers signed up yet. Invite Customers to start using ImmiBox" heading="No Customers Found" type='petitioner' />
    <NoDataFound :loading="!contentLoaded" v-if="users.length == 0 && callFromSerch" content="" heading="No Results Found" type='petitioner' />

    <div class="accordian-table" v-if="users.length>0">
      <vs-table :data="users"  >
        <template slot="thead"  >
        <!---
        "name":1,
        "email":1,
      'createdByName':1,
      "stautsName":1,
      'customId':1,
      "createdOn":-1,
      "updatedOn":1
        ---->
          <vs-th>
           <a @click="sortMe('name')"  v-bind:class="{'sort_ascending':sortKeys['name']==1, 'sort_descending':sortKeys['name']!=1}" >
             Name
              </a>
          </vs-th>
           <vs-th>
            
           <a @click="sortMe('email')"  v-bind:class="{'sort_ascending':sortKeys['email']==1, 'sort_descending':sortKeys['email']!=1}" >
              Email
              </a>
           </vs-th>
          <vs-th>  
          <a @click="sortMe('customId')"  v-bind:class="{'sort_ascending':sortKeys['customId']==1, 'sort_descending':sortKeys['customId']!=1}" >
              Cust ID
              </a>
          </vs-th>
          <vs-th>
              <!-- 
              <a @click="sortMe('stautsName')"  v-bind:class="{'sort_ascending':sortKeys['stautsName']==1, 'sort_descending':sortKeys['stautsName']!=1}" >
              -->
               Profile Status
               <!--</a>-->
       
              
          </vs-th>
         
          <vs-th>
         <!-- <a @click="sortMe('statusDetails.name')"  v-bind:class="{'sort_ascending':sortKeys['statusDetails.name']==1, 'sort_descending':sortKeys['statusDetails.name']!=1}" >
              -->
              Status
              <!--</a>-->
          </vs-th>
          <vs-th>
          <a @click="sortMe('createdOn')"  v-bind:class="{'sort_ascending':sortKeys['createdOn']==1, 'sort_descending':sortKeys['createdOn']!=1}" >
              Created On
              </a>
          </vs-th>
           <vs-th class="actions">
             <span>Actions</span>
           </vs-th>
        </template>
       
        <template slot-scope="{data}">
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.name" class="cursor" >
               <div class="d-inline-flex align-center"  @click="goToDetails(tr._id)">
               <template v-if="checkProperty(tr, 'name')"> 
               <!-- <img   class="user-image" :src="checkProperty(tr, 'name')"  @error="setDefaultPhoto($event ,'' )" /> -->
               <avatar :size="36" :backgroundColor="'#0E1D48'"  :initials="avtarName(tr, 'name')"></avatar>
             </template> 
               <div >
                {{tr.name }} <br/> 
                <span class="user_role">{{checkProperty( tr ,"typeDetails" ,"name")}}</span>
                </div>
              <!-- <a href="">{{tr.name}}</a> -->
              </div>
            </vs-td>
            
           
             <vs-td :data="tr.adminEmail">{{tr.adminEmail}}</vs-td> 
            <vs-td :data="tr.customId">{{tr.customId}}</vs-td> 
            

            <vs-td >
              <span class="statusspan " :class="{'status_pending':checkProperty(tr ,'profCompleted')=='No','status_active':checkProperty(tr ,'profCompleted')=='Yes'}">
              {{checkProperty(tr ,'profCompleted')=='No'?'Pending':'Completed'}}
              </span>
            </vs-td>
           

           <vs-td :data="tr.statusDetails">
              <span class="statusspan " :class="{'status_pending':tr.statusId==1,'status_active':tr.statusId==2,'status_rejected':tr.statusId==3,'status_deleted':tr.statusId==4}" >
              {{checkProperty(tr ,"statusDetails" ,'name')}}
              
              </span>
            </vs-td>
            <vs-td :data="tr.createdOn">
              <span  >{{ tr.createdOn | formatDate }}</span>
            </vs-td>
            <vs-td >
               <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent><more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon></a>
                 <vs-dropdown-menu class="loginx msg_dropdown">
                
                 <vs-dropdown-item>
                    <a  href.prevent  style="cursor:pionter;padding:3px 10px"   @click="goToDetails(tr._id)"><span>Details</span></a>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.statusId<=1">
                    <a  href.prevent  style="cursor:pionter;padding:3px 10px"   @click="openApprovepopup(tr ,2,'Approve')"><span>Approve</span></a>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.statusId<=1" >  
                    <a href.prevent style="cursor:pionter;padding:3px 10px"   @click="openApprovepopup(tr ,3,'Reject')"><span>Reject</span></a>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkProperty(tr ,'userDetails' ) &&  checkProperty(tr ,'userDetails' ,'statusId')<=1 && tr.statusId!=3">  
                    <a href.prevent style="cursor:pionter;padding:3px 10px"   @click="resend(tr)"><span>Resend Activation Link </span></a>
                  </vs-dropdown-item>
                  <!---

                   <vs-dropdown-item >  
                    <a href.prevent style="cursor:pionter;padding:3px 10px"   @click="openPopupCustomDomain(tr)"><span>Update Custom Domain </span></a>
                  </vs-dropdown-item>
                  -->
                  
                  </vs-dropdown-menu>     
                </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <paginate  v-if="users.length>0"  v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2" :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
        :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
    </div>
    <vs-popup class="holamundo main-popup" title="Invite Customer" v-if="inviteTenant" :active.sync="inviteTenant">
      <form>
        <div class="form-container">
          <div class="vx-row" @click="formerrors.msg=''">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Company Name<em>*</em></label>
                <vs-input :key="'companyname'" type="text" 
                class="w-full no-icon-border" 
                name="companyname" 
                key="companyname" 
                data-vv-as="Company Name" 
                v-model="new_user.name" 
                v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('companyname')">{{ errors.first("companyname") }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="form_group">
                <label class="form_label">First Name<em>*</em></label>
                <vs-input  :key="'adminFirstName'" type="text" class="w-full no-icon-border" name="adminFirstName" key="adminFirstName"  data-vv-as="First Name" v-model="new_user.adminFirstName" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('adminFirstName')">{{ errors.first("adminFirstName") }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="form_group">
                <label class="form_label">Last Name<em>*</em></label>
                <vs-input :key="'adminLastName'" type="text" class="w-full no-icon-border" name="adminLastName" key="adminLastName" data-vv-as="Last Name" v-model="new_user.adminLastName" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('adminLastName')">{{ errors.first("adminLastName") }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="form_group">
                <label class="form_label">Email ID<em>*</em></label>
                <vs-input :key="'email'" v-model="new_user.adminEmail" class="w-full no-icon-border" key="email" name="email" data-vv-as="Email ID" autocomplete="off" autocorrect="off" autocapitalize="none" v-validate="'required|email'" />
                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="form_group ph_number">
              <div class="vs-component">
              <label for="" class="form_label">Phone Number<em>*</em></label>
              <VuePhoneNumberInput

               autocomplete="off" 
               autocorrect="off"
                icon-pack="feather"
                class="w-full no-icon-border"
                :no-example="false"
                name="phone"
                key="phone"
                v-bind="vuePhone.props"
                v-validate="'required'"
                default-country-code="US"
                :no-country-selector="false"
                v-model="new_user.phone"
                data-vv-as="Phone Number"
                  @update="updatePhone"
                  :preferred-countries="['US', 'IN']"
                />
               <span class="text-danger text-sm"   v-show="!isPhoneValid && !errors.has('phone')" >*Invalid phone number - Please enter a valid one</span>

               <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>
              </div>      
              </div>
            </div>

           

              <div class="vx-col w-full">
                 <div class="form_group">
                  <label class="form_label">Company Type?<em>*</em></label>

                  <div class="register">
                    <ul class="custom-radio" vs-type="flex" vs-align="center">
                      <li v-for="(tenant, index) in tenantTypes" :key="index">
                        <vs-radio
                          data-vv-as="Company Type"
                          v-validate="'required'"
                          name="tenantType"
                          v-model="selectedTenantType"
                          vs-name="radios1"
                          :vs-value="tenant"
                          >{{ tenant.name }}</vs-radio
                        >
                      </li>
                    </ul>
                  </div>

                  <span
                    class="error-text pt-0"
                    v-show="errors.has('tenantType')"
                    >{{ errors.first("tenantType") }}</span
                  >
              </div>
                </div>
          </div>


          <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <vs-button color="dark" @click="inviteUserPopupshow(false)" class="cancel" type="filled">Cancel</vs-button>
          <vs-button color="success" :disabled="userCreating"  @click="tenantInvite()" class="save" type="filled">Invite</vs-button>
        </div>
      </form>
    </vs-popup>

    

    <vs-popup class="holamundo main-popup" :title="popupbtnTxt+' Customer'" :active.sync="approveConformpopUp">
      <div class="form-container">
        
        <div class="vx-row" v-if="[2].indexOf(selectedStatus)>-1" >
          <div class="vx-col w-full">
            <p>{{actionText}}</p>            
          </div>
                    
        </div>

        <!--------------If reject take comment------->
          <div v-if="[3,4,5].indexOf(selectedStatus)>-1" class="vx-row">
          
          


          <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Comments</label>

                       <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="actionComent" 
                  name="receiptName"
                  
                  class="w-full"
                /> -->
                <ckeditor data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="actionComent" 
                  name="receiptName"
                  
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                <span class="text-danger text-sm" v-show="errors.has('receiptName')">{{ errors.first("receiptName") }}</span>
                </div>


           
              </div>
              
     

         
          </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="approveConformpopUp=false;selectedStatus=0;actionComent=''">Cancel</vs-button>
        <vs-button color="success" class="save" :disabled="([3,4,5].indexOf(selectedStatus)>-1  && actionComent=='') || userCreating" type="filled" @click="changetenantStatus()">{{popupbtnTxt}} </vs-button>
      </div>
    </vs-popup>

    <modal
            name="updateCustomDomainPopupModal"
            classes="v-modal-sec"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="400px"
            height="auto"
          >
          <div class="v-modal profile_details_modal">
            <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">Custom Domain </h2>
              <span @click="$modal.hide('updateCustomDomainPopupModal');">
                <em class="material-icons">close</em>
              </span>
            </div>
              
            <form @submit.prevent data-vv-scope="customDomainForm">
             <div class="form-container">
                 
              <div class="vx-row"  @click="updatingDomainNameFormErrors=''">

             

               <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Custom Domain</label>
                <vs-input :key="'domainName'"
              type="text" 
               v-validate="'required|min:4|max:30'"
               oninput="this.value = this.value.replace(/[^a-z A-Z 0-9 -]/g, '');"
              data-vv-as="Domain Name"
              name="domainName"               
              v-model="domainName"
              placeholder="Domain Name"
              class="w-full no-icon-border"
              ref="caseCode"
            />

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('customDomainForm.domainName')"
                >{{ errors.first("customDomainForm.domainName") }}</span>
              </div>
              </div>
 

               
              </div>
              <div v-show="updatingDomainNameFormErrors">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                  icon="IP-information-button" active="true">{{ updatingDomainNameFormErrors }}</vs-alert>
              </div>

              <div class="popup-footer relative" >

              <span class="loader" v-if="updatingDomainName" ><img src="@/assets/images/main/loader.gif"></span>
               
          <vs-button  color="success" :disabled="updatingDomainName"  @click="updateTenantDomain()" class="save" type="filled">Update
           
          </vs-button>
        </div>
        
             </div>
             </form>
          </div>
</modal>   
  </div>
</template>

<script>
  import Datepicker from "vuejs-datepicker-inv";
  import Paginate from "vuejs-paginate";
  import Avatar from 'vue-avatar'
import DateRangePicker from "vue2-daterange-picker";
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
   import moment from 'moment'
  import PhoneMaskInput from "vue-phone-mask-input";
  import JQuery from 'jquery'
  import { TheMask } from 'vue-the-mask'
  import { MoreVerticalIcon } from 'vue-feather-icons'
  import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import NoDataFound from "@/views/common/noData.vue";

  export default {
    components: {
      
      DateRangePicker,
      VuePhoneNumberInput,
      Datepicker,
      Paginate,
      MoreVerticalIcon,
      FormWizard,
      TabContent,
      PhoneMaskInput,
      TheMask,
      Avatar,
      NoDataFound
    },

    data: () => ({
      editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
      domainName:'',
      updatingDomainName:false,
      updatingDomainNameFormErrors:'',

      tenantTypes:[],
      selectedTenantTypeForFilter:[],
      selectedTenantType:null,

      userCreating:false,
      contentLoaded:false,
      isPhoneValid:true,
      callFromSerch:false,
       selected_createdDateRange: ["", ""],
    autoApply: "",
      sortKeys:{},
    sortKey:{},
    actionComent:'',
       tenant: {
                name: "",
                adminFirstName:"",
                adminLastName:"",
                email: "",
                phoneCountryCode:{countryCode:'',countryCallingCode:''},
                roleId:"1",
                phone:"",
                password: "",
                confirm_password: "",
                invite:true
                
            }, 
      vuePhone:{
        props:{
          translations:{
            phoneNumberLabel:"Phone Number"
          }
        }

      }, 
      selectedTenant:null,
      selectedStatus:2,
      actionText:"Do you want to approve?",
      formerrors: {
        msg: ""
      },
      date: null,
      visatype: {
        id: 1,
        name: "H1B"
      },
      visasubtype: null,
      visasubtype: null,
      selectedUser: null,
      selectedUsername: null,
      approveConformpopUp: false,
      selected_roleID:'1',
      new_user: {
        firstName: "",
        lastName:"",
        roleId:"1",
        email: "",
        phone:"",
        active:true,
        phone:'',
         phoneCountryCode:{countryCode:'',countryCallingCode:''},
        address: {
          "line1": "",
          "line2": "",
          "locationId": "",
          "stateId": "",
          "countryId": 231,
          "zipcode": ""
        }
      },
      users: [],
      inviteTenant: false,
      NewPetition: false,
      visatypes: [],
      visasubtypes: [],
      searchtxt: "",
      query: [],
      country_code: 231,
      all_statusids: [],
      selected_statusids: [],
      final_selected_statusids: [],
      filter_roleIds: [],
      final_filter_roleIds: [1,2,3,4,5,8,9,10,11,12],

      all_states: [],
      seleted_states: [],
      final_selected_states: [],
      locations: [],
      // locationIds
      all_locations: [],
      seleted_locations: [],
      final_selected_locations: [],
      date: "",
      date_range: [],
      page: 1,
      perpage: 25,
      totalpages: 0,
      all_userroles: [],

      selected_userrole: '',
      switch2:true,
      users_status:{},
      popupbtnTxt:'',
     countries:[],
     states:[],
     locations:[],
     selectedCountry:null,
     selectedState:null,
     selectedCityes:[],
    }),
    watch: {
      searchtxt: function (value) {
        this.getenants(true);
      },
      
      '$route.query.filter':function (val) {
        
          this.getenants(false);
      }
        

    },
    methods: {
      openPopupCustomDomain(item){
        this.selectedTenant  =item
        this.domainName = ''
        this.updatingDomainName =false;
        this.updatingDomainNameFormErrors ='';
        this.$validator.reset();
      this.$modal.show('updateCustomDomainPopupModal');

      },
      updateTenantDomain(){

      },
       changedCountry(){
            /*
            countries:[],
     states:[],
     locations:[],
     selectedCountry:null,
     selectedState:null,
     selectedCityes:[],
    */
      if( this.selectedCountry && _.has(this.selectedCountry , "id")){
          this.masterData('states');
      }
      
      },
      changedState(){
        
          this.locations =[];
          if( _.has(this.selectedState , "id")){
            this.masterData('locations');
        }
      },
    //locationId
    changedCity(){

      if( _.has(this.selectedCity , "id")){
            //this.updateTenantData.address.locationId = this.updateTenantData.address.selectedCity['id'];
            this.masterData('locations');
        }

    },
       masterData(category="countries"){

        /*
      countries:[]
      states:[],
      locations:[],
        */
      let matcher ={};
        let postData = {
      matcher: matcher,
      page:1,
      perpage: 1000,
      category: category,
      
    };
    if(category =="states"){

        matcher = { "countryId": this.selectedCountry['id']}
    }
      if(category =="locations"){

        matcher = { "stateId": this.selectedState['id']  }
    }
      postData['matcher'] = matcher;

        this.$store.dispatch("getMasterData" , postData)
        .then((res)=>{
            //countries
            
            if(category == "countries"){

                this.countries = res['list'];
               
                //alert(JSON.stringify(this.countries))
            }
            if(category =="states"){


                this.states= res['list'];
               
                
                
            }
          if(category =="locations"){
            
              this.locations= res['list'];
             
              
          }
        })
        .catch((err)=>{
            this[category] =[];

        })

    },
      resend(item){
        this.selectedItem = item;
        let obj = { "email": this.selectedItem['adminEmail'] ,"tenantId":item['_id']};
        this.$store
              .dispatch("resend", obj)
              .then(response => {
                //alert(JSON.stringify(response.data.message))
                   if (response.error) {
                  
                     this.showToster({message:response.error.message ,isError:true})
                } else {
                  this.showToster({message:response.data.message ,isError:false})
                  
                }
                
              })
              .catch((err)=>{
                this.showToster({message:err ,isError:true});

              });

      },
      goToDetails(id){
        this.$router.push('/customer-details/'+id);
      },
      sortMe(sort_key=''){

      //   this.sortKeys = {
      //   'caseNo':1,
      //   'beneficiaryDetails.name':1,
      //   "typeDetails.name":1,
      //   "petitionerDetails.name":1,
      //   "updatedOn":1,
      //   "communicationDetailslength":1

      // }

      if(sort_key !=''){
          this.sortKeys[sort_key] = this.sortKeys[sort_key]==1?-1:1
          this.sortKey ={};
          this.sortKey = {"path":sort_key ,"order":this.sortKeys[sort_key]}

          localStorage.setItem('tenant_sort_key', sort_key);
          localStorage.setItem('tenant_sort_value', this.sortKey[sort_key]);
          this.getenants();
      }
      },
     updatePhone(item) { 
       
      if (item.isValid) {  
         this.isPhoneValid = true;
       this.new_user.phoneCountryCode = {countryCode:item.countryCode,countryCallingCode:item.countryCallingCode};
       this.new_user.phone = item.nationalNumber;
       
      }else{

        this.isPhoneValid = false;
      }
     },
     inviteUserPopupshow(action =true){
       this.userCreating =false
      
       this.new_user =  {
                name: "",
                firstName:"",
                lastName:"",
                adminEmail: "",
                phoneCountryCode:{countryCode:'',countryCallingCode:''},
                roleId:"1",
                phone:"",
                password: "",
                confirm_password: "",
                 invite:true,
                 typeId:''
                
            }
      this.selectedTenantType =null;      
      this.inviteTenant=action;
      if(this.checkProperty(this.tenantTypes , "length" ) >0){
           this.selectedTenantType = this.tenantTypes[0]
         }
      setTimeout(()=>{ 
                    this.isPhoneValid=true;
                   
               } ,100);
               this.$validator.reset();
               Object.assign(this.formerrors, {
                    msg:''
                  });
     },
      
      openApprovepopup(item ,status=2 ,txt=''){

        this.actionText = "Do you want to "+txt+"?",
        this.actionComent ='';
        this.popupbtnTxt = txt;
        this.selectedTenant = item;
        this.selectedStatus = status;
        this.userCreating =false;
        this.approveConformpopUp =true;
         this.$validator.reset();

      },
  
      getenants(callFromSerch=false) {
        this.callFromSerch = callFromSerch;
        this.contentLoaded = false;
        let matcher = {
          title: this.searchtxt,
          statusIds: this.final_selected_statusids,
          "typeIds":[],
           "countryIds": [],
			    "stateIds": [],
			    "locationIds": [],
          createdDateRange:[]
          
        };
        

        //filter Country and staet and locations
        
         if(this.selectedCountry && _.has(this.selectedCountry ,"id")){
           matcher['countryIds'] = [this.selectedCountry['id']]

         }
         if(this.selectedState && _.has(this.selectedState ,"id")){
           matcher['stateIds'] = [this.selectedState['id']]

         }

         if(this.selectedCityes &&this.selectedCityes.length>0 ){
           // _.has(this.selectedCountry ,"id")
           _.forEach(this.selectedCityes,(item)=>{

              if( _.has(item ,"id")){
                  matcher['locationIds'].push(item['id']);

              }


           })
          

         }

         if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }

      if(this.selectedTenantTypeForFilter.length>0){

        matcher['typeIds'] = this.selectedTenantTypeForFilter.map((item)=>item.id)

      }

      if(this.checkProperty(this.$route ,'query' ,'filter')){
        try{
           let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
          var actual = JSON.parse(atob(filter));
          let keys = Object.keys(actual);
          if(this.checkProperty(keys ,'length') >0){
            
          _.forEach(actual ,(item ,key) => {
              if(key=='matcher' ){
                if((Object.keys(item)).length>0 ){
                 _.forEach(item ,(fval ,fKey)=>{
                      matcher[fKey] = fval;
                 });
                  //obj['matcher'] = item
                }
              
              }
          })
           
          }

        }catch(e){
         

        }
        
          
      }






      let query = {};
        query['page'] = this.page;
        query['perpage'] = this.perpage;
        query['filters'] = matcher;
        query['sorting'] = this.sortKey;
       

        this.$store
          .dispatch("getList",{data:query ,path:'/tenant/list'} )
          .then(response => {
            this.users = response.list;
             this.contentLoaded = true;
            this.totalpages = Math.ceil(response.totalCount / this.perpage);
            //alert(this.perpage);
          });
      },
      tenantInvite() {
        //this.new_user['roleId'] = this.selected_roleID['id'];
        this.$validator.validateAll().then(result => {
          if (result && this.isPhoneValid) {
            this.userCreating =true;

            if(_.has(this.selectedTenantType ,"id")){
                    this.new_user['typeId'] = this.selectedTenantType['id']

              }

            this.$store
              .dispatch("tenantInvite", this.new_user)
              .then(response => {
                  this.userCreating =false;
                if (response.error) {
                  Object.assign(this.formerrors, {
                    msg: response.error.message
                  });
                } else {
                  this.showToster({message:response.data.message,isError:false});
                  this.getenants();
                }
                this.inviteUserPopupshow(false);

                // this.$router.go('/beneficiaries');
              })
              .catch((err)=>{
                 this.userCreating =false;
                Object.assign(this.formerrors, {
                    msg: err
                  });

              })
          }
        });
      },
      
      get_statusids() {
        
        const item ={
          page:1,
          perpage: 10000,
          category: "tenant_status",
          
          
        };
        this.$store.dispatch("getMasterData", item).then(response => {
          this.all_statusids = response.list;
          this.all_statusids = _.filter(this.all_statusids ,(item)=>{
            return [1,2,3].indexOf(item['id'])>-1;

           })
          
        });
      },
      
      set_filter: function () {
        this.$refs["filter_menu"].dropdownVisible = false;
        this.final_selected_statusids = [];
        if (this.selected_statusids.length > 0) {
          this.final_selected_statusids = [];
          for (let ind = 0; ind < this.selected_statusids.length; ind++) {
            let current_index = this.selected_statusids[ind];
            this.final_selected_statusids.push(current_index["id"]);
          }
        }

        this.getenants(true);
      },
      clear_filter: function () {
          this.selectedTenantTypeForFilter =[];
          this.searchtxt ='';
        this.$refs["filter_menu"].dropdownVisible = false;
        this.selected_statusids = [];
        this.final_selected_statusids = [];

         this.selectedCountry =null
         this.selectedState =null;
         this.selectedCityes= [];
         this.selected_createdDateRange["startDate"] = "";
         this.selected_createdDateRange["endDate"] = "";
      
        this.date = "";
        this.date_range = [];
        this.$router.push({ query: {} })
        this.getenants();
      },
      pageNate(pageNum) {
        this.page = pageNum;
        this.getenants();
      },
      
      changetenantStatus( ){
        let post_data = {"tenantId":this.selectedTenant['_id'], "statusId":this.selectedStatus }
        //post_data = Object.assign(post_data,{"tenantId":this.selectedTenant['_id'] ,"statusId":this.selectedStatus})
      let action ="changetenantStatus"
       if(this.selectedStatus ==4){
        action = "deleteTenant"
       }
       if( this.actionComent =='' && [3,4,5].indexOf(this.selectedStatus)>-1 ){
         return true;

       }
       if([3,4,5].indexOf(this.selectedStatus)>-1){
        post_data = Object.assign(post_data,{"comment":this.actionComent}) ;
       }
       //alert(action)
       this.userCreating =true;
       this.$store.dispatch(action, post_data)
          .then(response => {
            this.approveConformpopUp =false;
            this.showToster({message:response.message,isError:false});
         
            this.getenants();
             this.userCreating =false;


          }).catch((er)=>{

            this.showToster({message:er,isError:true});
              this.userCreating =false;
          
        });
      },

    },
    mounted() {
      this.selectedTenantType =null;
      this.tenantTypes =[];
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.seleted_states = [];
      this.final_selected_states = [];

      this.seleted_locations = [];
      this.final_selected_locations = [];
       this.$store.dispatch("getmasterdata", "tenant_type").then(response => {
         this.tenantTypes = response;
         if(this.checkProperty(this.tenantTypes , "length" ) >0){
           this.selectedTenantType = this.tenantTypes[0];
           
         }
         


          if(this.checkProperty(this.$route ,'query' ,'filter')){
        try{
           let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
          var actual = JSON.parse(atob(filter));
          let keys = Object.keys(actual);
          if(this.checkProperty(keys ,'length') >0){
            
          _.forEach(actual ,(item ,key) => {
              if(key=='matcher' ){
                if((Object.keys(item)).length>0 ){
                 _.forEach(item ,(fval ,fKey)=>{
                     if(fKey=="typeIds"){

                       let tenantType= _.find( this.tenantTypes ,{"id":fval[0]});

                     if(tenantType){

                      this.selectedTenantTypeForFilter =[this.selectedTenantType];

                     }
                      
                  
                 //  alert(JSON.stringify(this.selectedTenantType));

                     }
                 });
                  //obj['matcher'] = item
                }
              
              }
          })
           
          }

        }catch(e){
         

        }
        
          
      }



        });
      this.masterData();
      /*
      {
			"path": "createdOn", // createdByName, stautsName, name, email, customId, updatedOn
			"order": 1
		}
    */

      this.sortKeys = {
        "name":1,
        "email":1,
      'createdByName':1,
      "stautsName":1,
      'customId':1,
      "createdOn":-1,
      "updatedOn":1
     
    },

    this.sortKey = {
      path:"createdOn",
      order:-1
    };

    if(localStorage.getItem('tenant_sort_key') && localStorage.getItem('tenant_sort_value')  && localStorage.getItem('tenant_sort_value') >=-1 ){
       this.sortKey = {};

      this.sortKey = {"path":localStorage.getItem('tenant_sort_key') ,"order":parseInt(localStorage.getItem('tenant_sort_value'))}
      //alert();

    }
    if(localStorage.getItem('tenant_perpage')){
        this.perpage = parseInt(localStorage.getItem('tenant_perpage'));
    }
      this.get_statusids();
      this.getenants();
     

    }
  };
</script>
